import type { Template } from '@ztechapps/common.contract'
import { AddTemplateFormModal, TemplateProvider } from '@ztechapps/webui.data-tools'
import React from 'react'

export type SaveTemplateModalProps = {
  category?: string
  filterCategory?: string
  onApply?: (args: { template: Template }) => void
  onClose?: () => void
  show: boolean
  initialValues: { category?: string; value: string }
  container?: HTMLElement
}

export const SaveTemplateModal = ({
  category,
  filterCategory,
  onApply,
  onClose,
  show,
  initialValues,
  container,
}: SaveTemplateModalProps) => {
  const onAdd = async (e) => {
    onApply?.({ template: e })
    onClose?.()
  }

  const trigger = () => null

  return (
    <TemplateProvider category={category} filterCategory={filterCategory} canSetDefault canLinkFilterTemplate>
      <AddTemplateFormModal
        onAdd={onAdd}
        show={show}
        onCancel={onClose}
        trigger={trigger}
        initialValues={initialValues}
        title="Save Templates"
        container={container}
      />
    </TemplateProvider>
  )
}
